module.exports = __webpack_public_path__ + "static/media/pdp_boat_banner.ef820c44.png";